<!--
  @description: 微信通知服务 - 通知任务页面
  @author: system
  @date: 2026-06-02
  @note: 包含时间周期配置、创建定时任务、手动发送通知三个Tab
-->
<template>
  <div class="task-manage-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-bell"></i>
        通知任务
      </h2>
      <p class="page-desc">时间周期配置、定时任务创建和手动发送管理</p>
    </div> -->

    <!-- Tab 切换 -->
    <div class="tabs-wrapper">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="card" class="custom-tabs">
        <!-- 时间周期配置 Tab -->
        <el-tab-pane label="时间周期配置" name="cycle">
          <template slot="label">
            <span class="tab-label">
              <i class="el-icon-alarm-clock"></i>
              时间周期配置
            </span>
          </template>
          <time-cycle-config ref="timeCycleConfig" />
        </el-tab-pane>

        <!-- 创建定时任务 Tab -->
        <el-tab-pane label="创建定时任务" name="task">
          <template slot="label">
            <span class="tab-label">
              <i class="el-icon-time"></i>
              创建定时任务
            </span>
          </template>
          <task-create ref="taskCreate" />
        </el-tab-pane>

        <!-- 手动发送通知 Tab -->
        <el-tab-pane label="手动发送通知" name="manual">
          <template slot="label">
            <span class="tab-label">
              <i class="el-icon-s-promotion"></i>
              手动发送通知
            </span>
          </template>
          <manual-send ref="manualSend" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
/**
 * @description 通知任务主页面
 * @component TaskManage
 */
import TimeCycleConfig from "./components/TimeCycleConfig.vue";
import TaskCreate from "./components/TaskCreate.vue";
import ManualSend from "./components/ManualSend.vue";

export default {
  name: "TaskManage",
  components: {
    TimeCycleConfig,
    TaskCreate,
    ManualSend
  },
  data() {
    return {
      // 当前激活的Tab页签
      activeTab: "cycle"
    };
  },
  created() {
    // 从路由参数读取激活的Tab（如果有）
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
  },
  methods: {
    /**
     * @description Tab切换事件
     * @param {Object} tab - 当前Tab对象
     */
    handleTabClick(tab) {
      // 更新路由参数，保留Tab状态
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: this.activeTab
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.task-manage-container {
  // padding: 20px;
  // min-height: 100vh;
  // background: #f5f7fa;

  // 页面头部
  .page-header {
    margin-bottom: 24px;
    padding: 24px 30px;
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(250, 112, 154, 0.3);

    .page-title {
      margin: 0 0 8px 0;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 12px;

      i {
        font-size: 32px;
      }
    }

    .page-desc {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
    }
  }

  // Tab包装器
  .tabs-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    padding: 20px;

    /deep/ .custom-tabs {
      .el-tabs__header {
        margin-bottom: 20px;
      }

      .el-tabs__nav {
        border: none;
      }

      .el-tabs__item {
        height: 50px;
        line-height: 50px;
        border: 1px solid #e4e7ed;
        border-radius: 8px 8px 0 0;
        margin-right: 8px;
        padding: 0 24px;
        font-size: 15px;
        transition: all 0.3s;

        &:hover {
          color: #165DFF;
        }

        &.is-active {
          background: #165DFF;
          color: #fff;
          border-color: transparent;
        }

        .tab-label {
          display: flex;
          align-items: center;
          gap: 8px;

          i {
            font-size: 18px;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .task-manage-container {
    padding: 10px;

    .page-header {
      padding: 20px;

      .page-title {
        font-size: 22px;

        i {
          font-size: 26px;
        }
      }
    }

    .tabs-wrapper {
      padding: 15px;

      /deep/ .custom-tabs {
        .el-tabs__item {
          padding: 0 16px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
